var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"activity-list span-6"},[_c('transition-group',{attrs:{"name":"fade","tag":"span"}},_vm._l((_vm.activities),function(activity){return _c(activity.component,_vm._g(_vm._b({key:activity.key,tag:"component"},'component',activity.data,false),activity.events))}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }